import { styled } from "styled-components";
import { device } from "../../styles/style";

export const Box = styled.div`
  display: flex;
  height: 20px;
  align-items: center;
  color: ${(props) =>
    props.$active ? "var(--mainTextColor)" : "var(--mainTextColorOpacity)"};
  transition: 500ms;
  cursor: pointer;

  &:hover {
    color: #000;

    > .dot {
      box-shadow: 0 0 3px var(--mainTextColorOpacity);
    }
  }

  p {
    transform: ${(props) => (props.$flip ? "scale(-1,-1)" : "")};
    text-align: ${(props) => (props.$flip ? "end" : "start")};
    width: 100px;
    font-size: 0.8rem;
    max-height: 2.4rem;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }

  @media ${device.mobileS} and ${device.tablet} {
    p {
      width: 15px;
      font-size: 0.2rem;
      max-height: 0.7rem;
    }
  }

  @media${device.tv} {
    p {
      width: 125px;
      font-size: 1rem;
      max-height: 3rem;
    }
  }

  @media${device.tvL} {
    p {
      width: 155px;
      font-size: 1.2rem;
      max-height: 3.5rem;
    }
  }

  @media${device.uhd} {
    p {
      width: 255px;
      font-size: 2rem;
      max-height: 5rem;
    }
  }
`;

export const Dot = styled.div`
  width: 20px;
  height: 20px;
  margin: 5px;
  background-color: ${(props) => props.$color};
  );
  border-radius: 50%;
  transition: 800ms;

  @media ${device.mobileS} and ${device.tablet} {
    width: 5px;
    height:5px;
    margin: 2px;
  }

  @media${device.tv} {
    width: 30px;
    height: 30px;
  }

  @media${device.tvL} {
    width: 50px;
    height: 50px;
  }

  @media${device.uhd} {
    width: 80px;
    height: 80px;
  }

 
`;
